import { createRouter, createWebHistory } from 'vue-router'
import { useStore } from 'vuex'; // Importa useStore

import DashboardView              from '../views/auth/DashboardView.vue'
// import ProfileView              from '@/views/ProfileView.vue'
// import PropertiesView           from '@/views/PropertiesView.vue'
// import CustomersView            from '@/views/CustomersView.vue'
import LoginView                  from '@/views/LoginView.vue'
import RestoreAccountView         from '@/views/RestoreAccountView.vue'
import InfoProfileView            from '@/views/auth/InfoProfileView.vue'
import InfoCompanyView            from '@/views/auth/InfoCompanyView.vue'

import CreateAccountView from '@/views/CreateAccountView.vue';
import UsersListView from '@/views/auth/users/UsersListView.vue';
import UserFormView from '@/views/auth/users/UserFormView.vue';
import UserFormEditView from '@/views/auth/users/UserFormEditView.vue';
import UserProfileView from '@/views/auth/users/UserProfileView.vue';
import ChangePasswordView from '@/views/auth/ChangePasswordView.vue';
import UsersView from '@/views/auth/UsersView.vue';
import RolFormList from '@/views/auth/catalogue//Rol/RolFormListView.vue';
import RolView from '@/views/auth/RolView.vue';
import CargoFormListView from '@/views/auth/catalogue/Cargo/CargoFormListView.vue';
import AccountFormList from '@/views/auth/catalogue/Account/AccountFormList.vue';
import PlanFormListView from '@/views/auth/catalogue/Plan/PlanFormListView.vue';
import RolFormView from '@/views/auth/catalogue/Rol/RolFormView.vue';
import CargoFormView from '@/views/auth/catalogue/Cargo/CargoFormView.vue';
import AccountFormView from '@/views/auth/catalogue/Account/AccountFormView.vue';
import PlanFormView from '@/views/auth/catalogue/Plan/PlanFormView.vue';
import CompanyListView from '@/views/auth/company/CompanyListView.vue';
import CompanyView from '@/views/auth/CompanyView.vue';
import CompanyFormView from '@/views/auth/company/CompanyFormView.vue';
import CompanyProfileView from '@/views/auth/company/CompanyProfileView.vue';
import PropertiesView from '@/views/auth/PropertiesView.vue';
//import PropertiesListView from '@/views/auth/properties/PropertiesListView.vue';
import PropertyFormView from '@/views/auth/properties/PropertyFormView.vue';
import AdvisorView from '@/views/auth/AdvisorView.vue';
import AdvisorListView from '@/views/auth/advisors/AdvisorListView.vue';
import AdvisorFormEditView from '@/views/auth/advisors/AdvisorFormEditView.vue';
import AdvisorProfileView from '@/views/auth/advisors/AdvisorProfileView.vue';
import AdvisorPropertiesFormView from '@/views/auth/advisors/AdvisorPropertiesFormView.vue';
import AdvisorNewFormView from '@/views/auth/advisors/AdvisorNewFormView.vue';
import PropertiesGridView from '@/views/auth/properties/PropertiesGridView.vue';
import BlogsView from '@/views/auth/BlogsView.vue';
import PostListView from '@/views/auth/blog/PostListView.vue';
import CategoriaListView from '@/views/auth/blog/CategoriaListView.vue';
import PostFormView from '@/views/auth/blog/PostFormView.vue';
import CategoryFormView from '@/views/auth/blog/CategoryFormView.vue';
import LegalListView from '@/views/auth/Legal/LegalListView.vue';
import LegalFormView from '@/views/auth/Legal/LegalFormView.vue';
import PorspectosView from '@/views/auth/PorspectosView.vue';
import ProspectoListView from '@/views/auth/prospectos/ProspectoListView.vue';
import ProspectoFormView from '@/views/auth/prospectos/ProspectoFormView.vue';
import CountruList from '@/views/auth/catalogue/Country/CountruList.vue';
import ReportsView from '@/views/auth/reports/ReportsView.vue';
import ReportListView from '@/views/auth/reports/ReportListView.vue';
import ReportReasonsListView from '@/views/auth/reports/ReportReasonsListView.vue';
import ReportReasonFormView from '@/views/auth/reports/ReportReasonFormView.vue';
import ReportReadView from '@/views/auth/reports/ReportReadView.vue';
import MyPropertyDetail from '@/views/auth/properties/PropertiesShowView.vue';

const routes = [
  {
    path: '/reports',
    name: 'reports',
    component: ReportsView,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'list',
        name: 'reports_list',
        component: ReportListView,
        meta: { requiresAuth: true }
      },
      {
        path: 'reasons',
        name: 'reports_reasons_list',
        component: ReportReasonsListView,
        meta: { requiresAuth: true }
      },
      {
        path: 'reason-form',
        name: 'reason-form',
        component: ReportReasonFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'reason-form/edit/:id',
        name: 'reason-form-edit',
        component: ReportReasonFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'read-report/:id', 
        name: 'read-report',
        component: ReportReadView,
        meta: { requiresAuth: true }
      }
    ]
  },

  { path: '/', redirect: '/login' },
  { path: '/country', component: CountruList },

  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/create-account',
    name: 'create_account',
    component: CreateAccountView
  },

  {
    path: '/forgot-password',
    name: 'forgot_password',
    component: RestoreAccountView
  },

  {
    path: '/restore_account/:token_temp',
    name: 'restore_account',
    component: RestoreAccountView
  },
  {
    path: '/info-company',
    name: 'info_company',
    component: InfoCompanyView,
    meta: { requiresAuth: true }
  },
  {
    path: '/info-profile',
    name: 'info_profile',
    component: InfoProfileView,
    meta: { requiresAuth: true }
  },
  {
    path: '/change-password/:token_temp',
    name: 'change_password',
    component: ChangePasswordView
  },
  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },

  {
    path: '/users',
    name: 'users',
    component: UsersView,
    meta: { requiresAuth: true },
    children:[
      {
        path: '',
        name: 'usersList',
        component: UsersListView,
        meta: { requiresAuth: true }
      },
      {
        path: '',
        name: 'usersform',
        component: UserFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'usersform/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'UserForm', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: UserFormEditView,
        meta: { requiresAuth: true }
      },
      {
        path: 'usersform/perfil/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'UserProfile', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: UserProfileView,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/catalogs',
    name: 'catalogs',
    component: RolView,
    meta: { requiresAuth: true },
    children:[
      {
        path: 'roles',
        name: 'roles',
        component: RolFormList,
        meta: { requiresAuth: true }
      },
      {
        path: 'roles-form',
        name: 'roles-form',
        component: RolFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'roles-form/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'roles-form-edit', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: RolFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'cargos',
        name: 'cargos',
        component: CargoFormListView,
        meta: { requiresAuth: true }
      },
      {
        path: 'cargos-form',
        name: 'cargos-form',
        component: CargoFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'cargos-form/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'cargos-form-edit', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: CargoFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'cuentas',
        name: 'cuentas',
        component: AccountFormList,
        meta: { requiresAuth: true }
      },
      {
        path: 'cuentas-form',
        name: 'cuentas-form',
        component: AccountFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'cuentas-form/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'cuentas-form-edit', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: AccountFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'planes',
        name: 'planes',
        component: PlanFormListView,
        meta: { requiresAuth: true }
      },
      {
        path: 'planes-form',
        name: 'planes-form',
        component: PlanFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'planes-form/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'planes-form-edit', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: PlanFormView,
        meta: { requiresAuth: true }
      },
      {
      path: 'countries',
      name: 'countries',
      component: CountruList,
      meta: { requiresAuth: true }
    },
    ]
  },
  {
    path: '/company',
    name: 'company',
    component: CompanyView,
    meta: { requiresAuth: true },
    children:[
      {
        path: 'company-list',
        name: 'company-list',
        component: CompanyListView,
        meta: { requiresAuth: true }
      },
      {
        path: 'company-form',
        name: 'company-form',
        component: CompanyFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'company-form/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'company-form-edit', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: CompanyFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'company-form/perfil/:id',
        name: 'company-profile',
        component: CompanyProfileView,
        meta: { requiresAuth: true }
      },
    ]
  },
  {
    path: '/Propiedades',
    name: 'properties',
    component: PropertiesView,
    meta: { requiresAuth: true },
    children:[
      //{
      //  path: '',
      //  name: 'propertyList',// properties/propertyList
      //  component: PropertiesListView,
      //  meta: { requiresAuth: true },
      //},
      {
        path: '',
        name: 'propertyGrid',// properties/propertyList
        component: PropertiesGridView,
        meta: { requiresAuth: true },
      },
      {
        path: 'form',
        name: 'propertyForm',
        component: PropertyFormView,
        meta: { requiresAuth: true },
      },
      {
        path: 'form/:id',
        name: 'propertyFormEdit',
        component: PropertyFormView,
        meta: { requiresAuth: true },
      },
      {
        path: '/form/:property_id',
        name: 'my_property_detail',// properties/propertyList
        component: MyPropertyDetail,
        meta: { requiresAuth: true },
      }
    ]
  },
  {
    path: '/advisors',
    name: 'advisors',
    component: AdvisorView,
    meta: { requiresAuth: true },
    children:[
      {
        path: '',
        name: 'advisorList',
        component: AdvisorListView,
        meta: { requiresAuth: true }
      },
      {
        path: '',
        name: 'advisorform',
        component: UserFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'NewAdvisorForm',
        name: 'AdvisorNewForm',
        component: AdvisorNewFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'advisorform/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'AdvisorForm', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: AdvisorFormEditView,
        meta: { requiresAuth: true }
      },
      {
        path: 'advisorform/perfil/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'AdvisorProfile', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: AdvisorProfileView,
        meta: { requiresAuth: true },
        props: route => ({ editMode: route.query.edit === 'true' })
      },
      {
        path: 'propertiesform/perfil/:advisorId/create/:create?',
        name: 'AdvisorPropertiesCreate',
        component: AdvisorPropertiesFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'propertiesform/property/edit/:propertyId',
        name: 'AdvisorPropertiesEdit',
        component: AdvisorPropertiesFormView,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/blog',
    name: 'blog',
    component: BlogsView,
    meta: { requiresAuth: true },
    children:[
      {
        path: 'post',
        name: 'post_list',
        component: PostListView,
        meta: { requiresAuth: true }
      },
      {
        path: 'post-form',
        name: 'post-form',
        component: PostFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'post-form/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'post-form-edit', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: PostFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'categorias',
        name: 'categorias_list',
        component: CategoriaListView,
        meta: { requiresAuth: true }
      },
      {
        path: 'category-form',
        name: 'category-form',
        component: CategoryFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'category-form/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'category-form-edit', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: CategoryFormView,
        meta: { requiresAuth: true }
      },
    ]
  },
  {
    path: '/legal',
    name: 'legal',
    component: BlogsView,
    meta: { requiresAuth: true },
    children:[
      {
        path: '',
        name: 'legal_list',
        component: LegalListView,
        meta: { requiresAuth: true }
      },
      {
        path: 'legal-form',
        name: 'legal-form',
        component: LegalFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'legal-form/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'legal-form-edit', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: LegalFormView,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/prospecto',
    name: 'prospecto',
    component: PorspectosView,
    meta: { requiresAuth: true },
    children:[
      {
        path: 'prospectos-list',
        name: 'prospectos-list',
        component: ProspectoListView,
        meta: { requiresAuth: true }
      },
      {
        path: 'prospectos-form',
        name: 'prospectos-form',
        component: ProspectoFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'prospectos-form/edit/:id', // Asegúrate de que la ruta tenga un parámetro `id`
        name: 'prospectos-form-edit', // Cambié el nombre a `UserForm` para que coincida con tu función
        component: ProspectoFormView,
        meta: { requiresAuth: true }
      },
      {
        path: 'compañia-form/perfil/:id',
        name: 'compañia-profile',
        component: CompanyProfileView,
        meta: { requiresAuth: true }
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach((to) => {
  if (to.meta.requiresAuth) {
    document.body.classList.remove('bg-dark_bg-100');
    document.body.classList.add('bg-white');
  } else {
    document.body.classList.remove('bg-white');
    document.body.classList.add('bg-dark_bg-100');    
  }
});

router.beforeEach((to, from, next) => {
  const store = useStore(); // Obtén la tienda Vuex
  const isAuthenticated = store.state.userSession; 

  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login');
  } else if (to.path === '/login' && isAuthenticated) {
    console.log(isAuthenticated)
    //next('/dashboard'); // Redirige al dashboard si está autenticado y trata de acceder a login
    if (isAuthenticated['step'] == 0) {
      //router.push({ name: "dashboard" });
      next('info-profile');      
    }else if (isAuthenticated['step'] == 1) {
      //router.push({ name: "dashboard" });
      next('info-company');
    }else if (isAuthenticated['step'] == 2) {
      //router.push({ name: "dashboard" });
      next('info-networks');      
    }else if (isAuthenticated['step'] == 3) {
      //router.push({ name: "dashboard" });      
      next('dashboard');  
    }
  } else {
    next();
  }

});
export default router
